import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as account from '../account'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: account.RESOURCE.payload.dimension.partialId,
      partialId: account.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Indicates the type of cost associated with this account',
    isOptional: true,
    name: 'Cost Type',
    partialId: PartialId.Standard.create('cost_type'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
